import React from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../ContextApi/GlobalContext";

/**
 * Native-style mobile top bar for the authenticated app.
 */
const MobileAppBar = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useGlobalContext();

  const pageName = state.pageName || "ContactHQ";
  const user = state.companyData || {};
  const userName = user.name || user.companyName || "User";
  const userInitial = userName.charAt(0).toUpperCase();
  const profilePicURL = user.profilePicURL || "";

  return (
    <header
      className="lg:hidden fixed top-0 left-0 right-0 z-[900] bg-[#0B1C2D] border-b border-white/[0.08] shadow-[0_8px_24px_rgba(11,28,45,0.35)]"
      style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
      role="banner"
    >
      <div className="h-[3.75rem] px-3 flex items-center gap-2">
        {/* Menu */}
        <button
          type="button"
          aria-label="Open menu"
          onClick={() => dispatch({ sideBar: true })}
          className="shrink-0 flex items-center justify-center size-11 rounded-2xl bg-white/[0.07] text-white active:bg-white/15 active:scale-95 transition-all"
        >
          <span className="material-symbols-outlined text-[24px]">menu</span>
        </button>

        {/* Title block — left-weighted like native apps */}
        <div className="flex-1 min-w-0 pl-1">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#E63946] leading-none mb-1">
            ContactHQ
          </p>
          <h1 className="text-[17px] font-bold text-white tracking-tight truncate leading-none">
            {pageName}
          </h1>
        </div>

        {/* Profile avatar */}
        <button
          type="button"
          aria-label="My profile"
          onClick={() => navigate("/myprofile")}
          className="shrink-0 relative flex items-center justify-center size-11 rounded-2xl overflow-hidden bg-gradient-to-br from-[#E63946] to-[#c1121f] text-white shadow-[0_4px_14px_rgba(230,57,70,0.35)] active:scale-95 transition-transform ring-2 ring-white/15"
        >
          {profilePicURL ? (
            <img
              src={profilePicURL}
              alt=""
              className="w-full h-full object-cover"
            />
          ) : (
            <span className="text-sm font-black">{userInitial}</span>
          )}
        </button>
      </div>
    </header>
  );
};

export default MobileAppBar;
